/* global Alpine */

/**
 * Store condiviso per il collegamento (traghetto/aliscafo) di un transfer.
 * Usato sia dal carrello che dal checkout: i pulsanti aprono lo stesso modal
 * (partial connection-modal.php) e il valore viene salvato subito su cart_transfers
 * tramite l'endpoint update-cart.
 */
export default function connectionModal() {
  document.addEventListener('alpine:init', () => {
    Alpine.store('connection', {
      // { itemId: { fromName, toName, connection } }
      data: {},
      strings: {},
      endpoint: '/api?endpoint=update-cart',

      open: false,
      id: null,
      draft: '',
      saving: false,
      error: null,

      hydrate(data, strings) {
        this.data = data || {}
        this.strings = strings || {}
      },

      value(id) {
        return (this.data[id] && this.data[id].connection) || ''
      },

      routeFor(id) {
        return this.data[id] || { fromName: '', toName: '' }
      },

      openModal(id) {
        this.id = id
        this.draft = this.value(id)
        this.error = null
        this.open = true
        document.body.style.overflow = 'hidden'
      },

      closeModal() {
        this.open = false
        this.id = null
        document.body.style.overflow = ''
      },

      async save() {
        if (this.saving || !this.id) return
        this.saving = true
        this.error = null
        const id = this.id
        const value = (this.draft || '').trim()
        try {
          const res = await fetch(this.endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ transfer_connections: { [id]: value } }),
          })
          const data = await res.json()
          if (!res.ok || data.error) {
            this.error =
              data.error ||
              this.strings.connectionError ||
              'Impossibile salvare il collegamento. Riprova.'
            return
          }
          if (!this.data[id]) {
            this.data[id] = { fromName: '', toName: '', connection: '' }
          }
          this.data[id].connection = value
          this.closeModal()
        } catch {
          this.error =
            this.strings.connectionError ||
            'Impossibile salvare il collegamento. Riprova.'
        } finally {
          this.saving = false
        }
      },
    })
  })
}
